import { render, staticRenderFns } from "./SideBarOption.vue?vue&type=template&id=b37a0cf2&"
import script from "./SideBarOption.vue?vue&type=script&lang=js&"
export * from "./SideBarOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports